import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import { Form, Input, Spin, Row, Col, Skeleton } from 'antd';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import { infoCb } from '@/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import myContext from '@/utils/createContext';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { getUrlParams, gtag, formatCardHolderIdNoVal, sessionStorage } from '@/utils/index.js';
import { BrSessionId } from '@/components/Common/riskCreateJs'

const FormItem = Form.Item;

const key = getUrlParams('key'); // 从 URL 中获取 key

function CPF(props) {
  const intl = props.intl;
  const { formatMessage } = intl;

  const cpfRef = useRef();
  const [beforeVal, setBeforeVal] = useState('');
  const [brSessionFlag, setBrSessionFlag] = useState(false)
  // radioValue 即为LCR 或者 ICR
  const { form, initData, resData, cashierData, radioValue, isMobileView, showDomain } = useContext(
    myContext,
  );
  const onChangeCPF = async function(e) {
  };

  useEffect(() => {
      // 收集巴西指纹
      BrSessionId()
      const clearTimer = setInterval(() => {
        sessionStorage.setItem('sessionId', document.getElementById('sessionId') ? document.getElementById('sessionId').value : '')

        if (sessionStorage.getItem('sessionId')) {
          clearInterval(clearTimer)
        }
      }, 150)     
  }, [intl.locale])

  const onBlurCPF = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入CPF']);
    gtag(`${showDomain}支付页面`, ['输入CPF']);
    showDomain ? gtag(`定制支付页面`, ['输入CPF']):'';
  };

  // 动态改变label的class的值值
  const setRefChange = cref => {
    // console.log(2222, cref.current);
    if (!_.isEmpty(cref.current)) {
      cref.current.setLabelClass();
    }
  };

  // 格式化CPF格式
  const getLastVal = val => {
    // console.log('val.length', val.length);
    if (val.length > 3 && val.length < 6) {
      val = val.substring(0, 3) + '.' + val.substring(3, 6);
    } else if (val.length === 6) {
      if (beforeVal.length === 5 || beforeVal.length === 7) {
        val = val.substring(0, 3) + '.' + val.substring(3, 6);
      }
      if (beforeVal.length === 6) {
        val = val.substring(0, 3) + '.' + val.substring(3, 6) + '.';
      }
    } else if (val.length > 6 && val.length < 9) {
      return (
        val.substring(0, 3) +
        '.' +
        val.substring(3, 6) +
        '.' +
        val.substring(6, 9)
      );
    } else if (val.length === 9) {
      if (beforeVal.length === 8 || beforeVal.length === 9) {
        val =
          val.substring(0, 3) +
          '.' +
          val.substring(3, 6) +
          '.' +
          val.substring(6, 9) +
          '-';
      }
      if (beforeVal.length === 10) {
        val =
          val.substring(0, 3) +
          '.' +
          val.substring(3, 6) +
          '.' +
          val.substring(6, 9);
      }
    } else if (val.length > 9) {
      val =
        val.substring(0, 3) +
        '.' +
        val.substring(3, 6) +
        '.' +
        val.substring(6, 9) +
        '-' +
        val.substring(9);
    }
    return val;
  };

  // 格式化CNPJ格式  XX.XXX.XXX/XXXX-XX
  const formatValToCNPJ = val => {
    if (val.length > 2 && val.length < 5) {
      val = val.substring(0, 2) + '.' + val.substring(2, 5);
    } else if (val.length === 5) {
      if (beforeVal.length === 4 || beforeVal.length === 5) {
        val = val.substring(0, 2) + '.' + val.substring(2, 5);
      }
      if (beforeVal.length === 6) {
        val = val.substring(0, 2) + '.' + val.substring(2, 5) + '.';
      }
    } else if (val.length > 5 && val.length < 8) {
      return (
        val.substring(0, 2) +
        '.' +
        val.substring(2, 5) +
        '.' +
        val.substring(5, 8)
      );
    } else if (val.length === 8) {
      if (beforeVal.length === 7 || beforeVal.length === 8) {
        val =
          val.substring(0, 2) +
          '.' +
          val.substring(2, 5) +
          '.' +
          val.substring(5, 8) +
          '/';
      }
      if (beforeVal.length === 9) {
        val =
          val.substring(0, 2) +
          '.' +
          val.substring(2, 5) +
          '.' +
          val.substring(5, 8);
      }
    } else if (val.length > 8 && val.length < 12) {
      return (
        val.substring(0, 2) +
        '.' +
        val.substring(2, 5) +
        '.' +
        val.substring(5, 8) +
        '/' +
        val.substring(8, 12)
      );
    } else if (val.length === 12) {
      if (beforeVal.length === 11 || beforeVal.length === 12) {
        val =
          val.substring(0, 2) +
          '.' +
          val.substring(2, 5) +
          '.' +
          val.substring(5, 8) +
          '/'+
          val.substring(8, 12) +
          '-'
      }
      if (beforeVal.length === 13) {
        val =
          val.substring(0, 2) +
          '.' +
          val.substring(2, 5) +
          '.' +
          val.substring(5, 8)+
          '/'+
          val.substring(8, 12)
      }
    }else if (val.length > 12) {
      val =
        val.substring(0, 2) +
        '.' +
        val.substring(2, 5) +
        '.' +
        val.substring(5, 8) +
        '/'+
        val.substring(8, 12) +
        '-'+
        val.substring(12);
    }
    return val;
  }
  
  // "cardHolderIdNo":"String",//证件号
  // "cardHolderIdType":"String",//证件类型，巴西传CPF
  return (
    <>
      {radioValue === 'LCR' || radioValue === 'PIX' || radioValue === 'BOL' ? (
        <div className="h5pc-cpf">
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item name="cardHolderIdType" noStyle>
                <Input type="text" type="hidden" />
              </Form.Item>
              <FloatLabel
                extra={radioValue === 'LCR' ? '' : (radioValue === 'PIX' && cashierData?.merchantSourceType === "SAILOR")?formatMessage({id: 'ga-checkout.sailor-payer-tips' }):formatMessage({id: 'ga-checkout.new-please-enter-cpf-extraTip' })}
                form={form}
                name="cardHolderIdNo"
                cref={cpfRef}
                label={(radioValue === 'PIX' && cashierData?.merchantSourceType === "SAILOR")?formatMessage({id: 'ga-checkout.sailor-payer-cpf' }):radioValue === 'LCR' ? formatMessage({id: 'ga-checkout.lcr-cpf-tip' }) : formatMessage({id: 'ga-checkout.new-placeholder-cpf-cnpj' })}
                className="ant-form-item-required"
                rules={[
                  {
                    required: true,
                    // message: `Please enter your CPF.`,
                    message: radioValue === 'LCR' || (radioValue === 'PIX' && cashierData?.merchantSourceType === "SAILOR") ? formatMessage({id: 'ga-checkout.please-enter-cpf' }) : formatMessage({id: 'ga-checkout.new-please-enter-cpf' }),
                  }, 
                  ({ getFieldValue }) => ({
                    validator: async (rule, value) => {
                      if (_.isEmpty(value)) return;
                      if (radioValue === 'LCR') {
                        const cpfNum = value.replace(/\.|-/g, '');
                        // 正常校验巴西的CPF号的方法
                        // console.log('cpfNum', cpfNum);
                        if (!cpf.isValid(cpfNum)) {
                          // console.log(value);
                          // return Promise.reject('Invalid CPF.');
                          return Promise.reject(
                            formatMessage({
                              id: 'ga-checkout.invalid-cpf',
                            }),
                          );
                        }
                      } 
                      if (radioValue === 'PIX' || radioValue === 'BOL') {
                        if (radioValue === 'PIX' && cashierData?.merchantSourceType === "SAILOR"){
                          const cpfNum = value.replace(/\.|-/g, '');
                          // 正常校验巴西的CPF号的方法
                          // console.log('cpfNum', cpfNum);
                          if (!cpf.isValid(cpfNum)) {
                            // console.log(value);
                            // return Promise.reject('Invalid CPF.');
                            return Promise.reject(
                              formatMessage({
                                id: 'ga-checkout.invalid-cpf',
                              }),
                            );
                          }
                        }else{
                          const newNum = value.replace(/\.|-|\//g, '');
                          const length = newNum.length;
                          if (!((length === 11 && cpf.isValid(newNum)) || (length === 14 && cnpj.isValid(newNum)))) {
                            return Promise.reject(
                              formatMessage({
                                id: 'ga-checkout.new-invalid-cpf-cnpj',
                              }),
                            );
                          } 
                        }
                      }                    
                    },
                  }),
                ]}
                getValueFromEvent={e => {
                  let val = e.target.value;
                  let newVal = val.replace(/[^0-9]/gi, '');
                  // console.log('beforeVal', beforeVal);
                  let lastVal = radioValue === 'LCR' ? getLastVal(newVal) : formatCardHolderIdNoVal(newVal);
                  // console.log('lastVal', lastVal);
                  form.setFieldsValue({ cardHolderIdNo: newVal });
                  setBeforeVal(form.getFieldValue('cardHolderIdNo'));
                  return lastVal;
                }}
              >
                <Input
                  size="large"
                  type="tel"
                  maxLength={radioValue === 'LCR'? 14 : 18}
                  onBlur={e => onBlurCPF(e)}
                  onChange={e => onChangeCPF(e)}
                />
              </FloatLabel>
            </Col>
          </Row>


          <Input
            size="large"
            maxLength={128}
            type="hidden"
            id="sessionId"
            defaultValue=""
          />
        </div>
      ) : null}
    </>
  );
}

export default injectIntl(CPF);
